import { useCallback, useSyncExternalStore } from 'react';

const MOBILE_QUERY = '(max-width: 640px)';

/**
 * Reactive media-query hook. SSR-safe via useSyncExternalStore
 * (server snapshot resolves to false — desktop-first default).
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (cb: () => void) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', cb);
      return () => mql.removeEventListener('change', cb);
    },
    [query]
  );

  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query]);

  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

/** Convenience wrapper kept for existing call-sites. */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}
